const api = 'https://spotwork.appchargespot.com/pb.php?'

const postReqest = async (formData, endpoint) => {
  const result = await fetch(`${api}${endpoint}`, {
    method: 'POST',
    mode: 'cors',
    body: formData
  })
    .then((res) => res.json())
    .catch((reason) => {
      console.log('error msg:', reason)
    })
  return result
}

const getUserBatteries = async (userId) => {
  const formData = new FormData()
  formData.append('user_group', 'spotwork')
  formData.append('user_id', userId)
  const result = await postReqest(formData, 'user')
  return result
}

module.exports = {
  getUserBatteries
}
